import {
  Typography,
} from '@material-ui/core'
import React from 'react'

export default function TextMaterial(props) {
  const { material } = props

  return <Typography variant="body1">{material.content}</Typography>
}